import moment from 'app/common/lib/momentRange'
import { dateFormat } from 'app/common/ui-next/plain-date-period'

import {
  getStateCurrentValue,
  getStateIsFilterActive,
  type State,
} from 'app/common/ui-components/filter'

import { filterId } from './filterId'

export const filterActive = (state: State): boolean => {
  return getStateIsFilterActive(filterId, state)
}

export const finalDateInPreviosMonthOrBefore = (state: State): boolean => {
  const [, dateTo] = getStateCurrentValue(filterId, state) || []
  const mDateTo = moment(dateTo, dateFormat)
  const valid = Boolean(dateTo && mDateTo.isValid())

  if (!valid) {
    return false
  }

  return mDateTo.isSameOrBefore(moment().subtract(1, 'months'), 'month')
}

export const finalDateInCurrentMonth = (state: State): boolean => {
  const [, dateTo] = getStateCurrentValue(filterId, state) || []
  const mDateTo = moment(dateTo, dateFormat)
  const valid = Boolean(dateTo && mDateTo.isValid())

  if (!valid) {
    return false
  }

  return mDateTo.isSame(moment(), 'month')
}

export const moreThanOneDaySelected = (state: State): boolean => {
  const [dateFrom, dateTo] = getStateCurrentValue(filterId, state) || []
  const mDateFrom = moment(dateFrom, dateFormat)
  const mDateTo = moment(dateTo, dateFormat)
  const valid = Boolean(dateFrom && dateTo && mDateFrom.isValid() && mDateTo.isValid())

  if (!valid) {
    return false
  }

  return moment.range(mDateFrom, mDateTo).diff('days') > 0
}
